export function firstLetterUpperCase(string: string): string {
  const firstLetter = string.charAt(0)
  const remainingLetters = string.substring(1)

  return firstLetter.toUpperCase() + remainingLetters
}

export function firstLetterLowerCase(string: string): string {
  const firstLetter = string.charAt(0)
  const remainingLetters = string.substring(1)

  return firstLetter.toLowerCase() + remainingLetters
}

export function removeHTMLTags(p: string): string {
  return p.replace(/<\/?[^>]+(>|$)/g, '')
}

const regexParagraph = /<p\b[^>]*>([\s\S]*?)<\/p>/gi
export function replaceParagraphWithBR(content: string): string {
  let match: RegExpExecArray | null

  const parts: string[] = []

  while ((match = regexParagraph.exec(content)) !== null) {
    parts.push(match[1])
  }

  if (parts.length > 0) {
    return parts
      .map((p, i) => `${p} ${i < parts.length - 1 ? '<br />' : ''}`)
      .join('')
  }

  return content
}
